import { css } from '@lastbrand/web-ui-styled-system/css'

// Replaces legacy `.container`, whose hardcoded `width: 40.8rem` balloons to 652.8px at the
// 16px DS root; on DS the host (PDP wrapper / popup) owns the column width.
export const containerDsClass = css({ width: '100%' })

// Option-group legend (replaces legacy `.container__label`).
export const labelDsClass = css({
  // legacy desktop label measures 13.33px / 20px line-height (1.2rem / 1.8rem at the capped 11.11px
  // fluid root); body-14 (14px / 20px bundled) is the closest token on both axes.
  textStyle: 'body-14',
  fontWeight: 500,
  color: 'black',
  display: 'flex',
  width: '100%',
  // Left-cluster the Size Chart trigger after the label (legacy pushed it to the right edge on mobile).
  justifyContent: 'flex-start',
  gap: 'space-4',
})

// Option-group layout (replaces legacy `.container__options`).
export const optionGroupDsClass = css({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: 'space-24',
})

export const optionLabelDsClass = css({ display: 'inline' })
export const selectedValueDsClass = css({ fontWeight: 400 })

// Low-inventory message (legacy `.selected_variant_available_inventory_message_newDesignV2`).
export const lowInventoryMessageDsClass = css({
  textStyle: 'body-14',
  color: 'red-100',
  textAlign: 'center',
  width: 'full',
  marginBottom: 'space-10',
  lgDown: {
    marginBottom: 'space-16', // legacy _adjustedPadding
    display: 'flex',
    alignItems: 'center',
    gap: 'space-8',
    textAlign: 'left',
    padding: 0,
  },
})

export const lowInventoryIconDsClass = css({
  display: 'none',
  lgDown: { display: 'block', width: '16px', height: '16px' },
})

// Klarna pay-later wrapper (legacy `.container__szmessage`).
export const klarnaWrapperDsClass = css({
  display: 'flex',
  justifyContent: 'flex-start',
  paddingTop: '14px', // no 14px spacing token
  paddingBottom: 'space-8',
  lineHeight: '16px',
})

// Subscription terms notice (legacy `.subscriptionTermsNotice`).
export const subscriptionTermsNoticeDsClass = css({
  textStyle: 'body-12',
  color: 'black',
  textAlign: 'left',
  marginTop: 'space-8',
})

export const subscriptionTermsNoticeLinkDsClass = css({
  textDecoration: 'underline',
  textUnderlineOffset: 'space-2',
})

/* ----- ProductDescFooter (legacy `ProductDescFooterV2.module.scss`, rem at the ~10px root) ----- */

export const descFooterDsClass = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  width: '100%',
  marginTop: 'space-10',
  gap: 'space-12',
})

export const descFooterRowDsClass = css({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 'space-8',
})

export const descFooterIconBoxDsClass = css({
  textAlign: 'center',
  width: '20px',
  height: '20px',
  display: 'flex',
  alignItems: 'center',
  // `!` needed to beat the Image atom's own object-fit (legacy does the same).
  '& img': { objectFit: 'contain!' },
})

export const descFooterIconDsClass = css({ width: '20px', height: '20px' })

export const descFooterTextDsClass = css({
  textStyle: 'body-14',
  textAlign: 'center',
  color: 'black',
})

// White-glove copy wraps onto two lines (legacy `.infoTextNewLine`).
export const descFooterTextColumnDsClass = css({ display: 'flex', flexDirection: 'column' })

export const descFooterEasyReturnsDsClass = css({
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
})

// Easy-returns policy modal (SECOND_RETURNS_CHARGING experiment).
export const easyReturnModalDsClass = css({
  height: '185px',
  width: '476px',
  padding: 'space-48',
  lgDown: {
    width: '100vw',
    height: '205px',
    paddingBlock: 'space-48',
    paddingInline: 'space-16',
    marginTop: 'calc(100vh - 190px)',
  },
})

export const easyReturnModalWrapperDsClass = css({
  lgDown: { background: 'darkgray-trans-50' },
})

export const easyReturnModalHeaderDsClass = css({
  textStyle: 'body-14',
  fontWeight: 500,
  letterSpacing: '0.06em',
  textAlign: 'left',
  marginBottom: 'space-8',
})

export const easyReturnModalSubTextDsClass = css({
  textStyle: 'body-12',
  textAlign: 'left',
  marginBottom: 'space-16',
})

export const easyReturnModalLinkDsClass = css({
  borderBottom: '1px solid token(colors.black)',
  fontSize: '11px',
  fontWeight: 400,
  lineHeight: '14px',
  textAlign: 'left',
})
